var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssigned = function SvgAssigned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 311 311"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 311.0781c-4.0977 0-8.1954-1.5586-11.3086-4.6953-6.25-6.25-6.25-16.3828 0-22.6328L283.789 4.6875c6.25-6.25 16.3828-6.25 22.6328 0s6.25 16.3828 0 22.6367L27.3633 306.3828c-3.1367 3.1172-7.2344 4.6953-11.3281 4.6953zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.1172 311.0781c-4.0977 0-8.1914-1.5586-11.3086-4.6953L4.7266 27.3242c-6.25-6.2539-6.25-16.3867 0-22.6367s16.3828-6.25 22.6367 0L306.4219 283.75c6.25 6.25 6.25 16.3828 0 22.6328-3.1367 3.1172-7.2305 4.6953-11.3047 4.6953zm0 0"
  })));
};
export default SvgAssigned;